import { BaseService } from '../services/base.service';

interface Type<T> {
  new (...args: any[]): T;
}

class Injector extends Map {
  public resolve<T>(target: Type<T>): T {
    const classInstance = this.get(target);
    if (classInstance) {
      return classInstance;
    }
    const newClassInstance = new target();
    this.set(target, newClassInstance);
    return newClassInstance;
  }
}

const injector = new Injector();
export const resolve = injector.resolve.bind(injector);
export default function useService<T extends BaseService>(
  serviceClass: Type<T>
): T {
  return injector.resolve(serviceClass);
}
